// extracted by mini-css-extract-plugin
export default {"party_subHeadline":"party_subHeadline_QMULc","Party__headline":"Party__headline_s_X95"};